import styled from 'styled-components';
import { FaUserCheck } from 'react-icons/fa';

export const SuccessSvg = styled(FaUserCheck)`
  font-size: 70px;

  color: var(--green);
`;
